import { useState, useRef } from 'react';

import { type IPageParams, type ISortData } from '../interface';

export const defaultPageParams: IPageParams = { page: 1, limit: 10 };

export type IFilter<T> = ISortData & IPageParams & T;

export default function useFilters<T>(initialFilter: IFilter<T>) {
	const initialFilterRef = useRef(initialFilter);
	const [filter, setFilter] = useState<IFilter<T>>(initialFilter);
	const [clear, setClear] = useState(0);

	const changePage = (page: number) => setFilter((f) => ({ ...f, page }));

	const sort = (column: ISortData) => setFilter((f) => ({ ...f, ...column, page: 1 }));

	const changePageSize = (limit: number) => setFilter((f) => ({ ...f, page: 1, limit }));

	const changeFilters = (values: Partial<T>) => {
		setFilter((f) => ({ ...f, ...values, page: 1 }));
	};

	const clearFilter = () => {
		setClear(Math.random());
		setFilter(initialFilterRef.current);
	};

	return {
		filter,
		clear,
		changePage,
		sort,
		changePageSize,
		changeFilters,
		clearFilter
	};
}
